import React, { MouseEventHandler, useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

type FilterType = Extract<OfferPageFilterType, 'airport' | 'checkin'>

function mapToFilterType(filter: string | undefined): FilterType {
  switch (filter) {
    case 'airport':
    case 'checkin':
      return filter
    default:
      throw new Error(`Unknown filter type: ${filter}`)
  }
}

interface Props {
  shouldChangeAirport: boolean;
  shouldChangeDepartureDate: boolean;
  onToggleFilter: (filter: FilterType) => void;
}

function PropertyUnavailableRateOptionCtas({
  shouldChangeAirport,
  shouldChangeDepartureDate,
  onToggleFilter,
}: Props) {
  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    onToggleFilter(mapToFilterType(event.currentTarget.dataset.filter))
  }, [onToggleFilter])

  return <>
    {shouldChangeAirport && <TextButton
      onClick={onClick}
      kind="tertiary"
      size="large"
      data-filter="airport"
    >
      Change airport
    </TextButton>}
    {shouldChangeDepartureDate && <TextButton
      onClick={onClick}
      kind="tertiary"
      size="large"
      data-filter="checkin"
    >
      Change departure date
    </TextButton>}
  </>
}

export default React.memo(PropertyUnavailableRateOptionCtas)
